import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { useIntl } from "react-intl";
import { MathJax } from 'better-react-mathjax';

export function MathJaxCell(props) {
  const formattedContent = props.text.map((text) => {
    try {
        const intl = useIntl();
        intl.formatMessage({
          id: text,
          defaultMessage: text,
          description: "",
        });
    } catch (error) {
        parse(text);
    }

    return text;
  })

  return (
    <td className={props.className} colspan={props.colspan}>
      <div className={`dataTable_row_fixed_contents`}>
        <MathJax>
          <p>{formattedContent}</p>
        </MathJax>
      </div>
    </td>
  );
}

MathJaxCell.propTypes = {
  /**
   * MathJax to be displayed on the cell
   */
  text: PropTypes.array,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
